'use strict';

var _regeneratorRuntime = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _defineProperty = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _asyncToGenerator = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CID = require('cids');

var _require = require('ipld-dag-pb'),
    DAGNode = _require.DAGNode;

var multipartRequest = require('../lib/multipart-request');

var configure = require('../lib/configure');

var toUrlSearchParams = require('../lib/to-url-search-params');

var abortSignal = require('../lib/abort-signal');

var _require2 = require('native-abort-controller'),
    AbortController = _require2.AbortController;

var unit8ArrayToString = require('uint8arrays/to-string');

var uint8ArrayFromString = require('uint8arrays/from-string');

module.exports = configure(function (api) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(obj) {
        var options,
            tmpObj,
            buf,
            controller,
            signal,
            res,
            _ref2,
            Hash,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                tmpObj = {
                  Links: []
                };

                if (!(obj instanceof Uint8Array)) {
                  _context.next = 6;
                  break;
                }

                if (!options.enc) {
                  tmpObj = {
                    Data: unit8ArrayToString(obj),
                    Links: []
                  };
                }

                _context.next = 16;
                break;

              case 6:
                if (!DAGNode.isDAGNode(obj)) {
                  _context.next = 10;
                  break;
                }

                tmpObj = {
                  Data: unit8ArrayToString(obj.Data),
                  Links: obj.Links.map(function (l) {
                    return {
                      Name: l.Name,
                      Hash: l.Hash.toString(),
                      Size: l.Tsize
                    };
                  })
                };
                _context.next = 16;
                break;

              case 10:
                if (!(typeof obj === 'object')) {
                  _context.next = 15;
                  break;
                }

                tmpObj.Data = unit8ArrayToString(obj.Data);
                tmpObj.Links = obj.Links;
                _context.next = 16;
                break;

              case 15:
                throw new Error('obj not recognized');

              case 16:
                if (obj instanceof Uint8Array && options.enc) {
                  buf = obj;
                } else {
                  options.enc = 'json';
                  buf = uint8ArrayFromString(JSON.stringify(tmpObj));
                } // allow aborting requests on body errors


                controller = new AbortController();
                signal = abortSignal(controller.signal, options.signal); // @ts-ignore https://github.com/ipfs/js-ipfs-utils/issues/90

                _context.t0 = api;
                _context.t1 = _objectSpread;
                _context.t2 = {
                  timeout: options.timeout,
                  signal: signal,
                  searchParams: toUrlSearchParams(options)
                };
                _context.next = 24;
                return multipartRequest(buf, controller, options.headers);

              case 24:
                _context.t3 = _context.sent;
                _context.t4 = (0, _context.t1)(_context.t2, _context.t3);
                _context.next = 28;
                return _context.t0.post.call(_context.t0, 'object/put', _context.t4);

              case 28:
                res = _context.sent;
                _context.next = 31;
                return res.json();

              case 31:
                _ref2 = _context.sent;
                Hash = _ref2.Hash;
                return _context.abrupt("return", new CID(Hash));

              case 34:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
});